import style from "./home_droplead_info.module.css";
// import Guide from "@/components/common/guide/guide";
// import DropLeadForm from "@/components/common/droplead-form/droplead_form";
// import { useRouter } from "next/router";
// import Button from "@/components/UI/button/button";
// import CustomerContext from "@/stores/customer-context";
// import { Fragment, useContext } from "react";
import useGtm, { GTM_EVENT } from "@/hooks/useGtm";
import InputText from "../UI/input/input_text";
export default function HomeDropLeadInfo({ values, onChange, onBlur, errors, touched, setFieldValue }) {
  const { onSendGtmEvent } = useGtm("infoForm");
  // const onSubmitHandler = async (customerDropleadInfo) => {
  //   try {
  //     // await customerCtx.setCustomerInfo(customerDropleadInfo, "droplead");
  //     onSendGtmEvent(GTM_EVENT.DROP_LEAD, {}, "calculate_form");
  //     // router.push("/calculate-plan/home-type");
  //   } catch (err) {
  //     console.log(err.message);
  //   }
  // };
  const onConsentChangeHandler = (e, setFieldValue, errors) => {
    setFieldValue("consent", e.target.checked);
  };
  return (
    <div className={style.droplead_wrapper}>
      <div className={`${style.field} ${style.first_name}`}>
        <InputText
          type="text"
          name="firstName"
          theme="black"
          title="ชื่อเจ้าบ้าน"
          placeholder="ชื่อเจ้าบ้าน"
          withRequiredMark={true}
          onChange={onChange}
          onBlur={onBlur}
          errorMsg={errors.firstName && touched.firstName ? errors.firstName : ""}
        />
      </div>
      <div className={`${style.field} ${style.last_name}`}>
        <InputText
          type="text"
          name="lastName"
          title="นามสกุลเจ้าบ้าน"
          theme="black"
          placeholder="นามสกุลเจ้าบ้าน"
          withRequiredMark={true}
          onChange={onChange}
          onBlur={onBlur}
          errorMsg={errors.lastName && touched.lastName ? errors.lastName : ""}
        />
      </div>
      <div className={`${style.field} ${style.phone}`}>
        <InputText
          type="tel"
          name="phone"
          title="เบอร์โทรศัพท์"
          theme="black"
          maxlength="10"
          placeholder="เบอร์โทรศัพท์"
          withRequiredMark={true}
          onChange={onChange}
          onBlur={onBlur}
          errorMsg={errors.phone && touched.phone ? errors.phone : ""}
        />
      </div>
    </div>
  );
}
